import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { UPDATE_MENSAGENS_CHAT_NAO_LIDAS } from "redux/constants/Menu";
import getSocketConfig from "views/app-views/chat/socketConfig";
import { PermissaoChatEnum } from "enum/permissao-enum";

/*
    Mantém o badge de mensagens não lidas (menu lateral + título da aba)
    sincronizado em tempo real, em qualquer página do app. Conecta um socket
    leve que escuta apenas o evento `chat:nao-lidas`, emitido pelo backend
    sempre que o total muda (nova mensagem, leitura, exclusão).
*/
export default function useChatNotifications() {
	const dispatch = useDispatch();
	const idUsuario = useSelector((state) => state.user?.id);
	const temPermissaoChat = useSelector(
		(state) => !!state.permissoes?.[PermissaoChatEnum.VISUALIZAR_CHAT],
	);
	const socketRef = useRef(null);

	useEffect(() => {
		if (!idUsuario || !temPermissaoChat) return undefined;

		const rawToken = localStorage.getItem(AUTH_TOKEN);
		if (!rawToken) return undefined;

		const token = rawToken.replace(/^Bearer\s+/i, "");
		const { origin, path } = getSocketConfig();

		const socket = io(origin, {
			path,
			auth: { token },
			transports: ["websocket"],
		});
		socketRef.current = socket;

		const onNaoLidas = (data) => {
			dispatch({
				type: UPDATE_MENSAGENS_CHAT_NAO_LIDAS,
				total: data?.total ?? 0,
			});
		};

		socket.on("chat:nao-lidas", onNaoLidas);

		return () => {
			socket.off("chat:nao-lidas", onNaoLidas);
			socket.disconnect();
			socketRef.current = null;
		};
	}, [idUsuario, temPermissaoChat, dispatch]);
}
